/* projects/fitnessforservice/src/app/type-a-component/verticalvessel/verticalvessel.component.css */
.hide-scrollbar {
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
/*# sourceMappingURL=verticalvessel.component.css.map */
